import { useState } from 'react'

const useEditorModal = () => {
  const [showEditorModal, setShowEditorModal] = useState(false)

  const handleOpenEditorModal = () => setShowEditorModal(true)
  const handleCloseEditorModal = () => setShowEditorModal(false)

  return { showEditorModal, handleOpenEditorModal, handleCloseEditorModal }
}

export default useEditorModal
